/**
 *
 * @author Matthew Rawson @ 22/02/2018 13:29
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import {greys, brand} from "@irati/ui/src/global/colors"


const Wrapper = styled.div`
  position: absolute;
  left: 15px;
  top: calc(50% - 3px);
  width: calc(100% - 30px);
  height: 6px;
  background-color: ${greys.light};
  pointer-events: none;
  user-select: none;
`

const Seek = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  background-color: ${() => brand.default};
  transition: width 0.25s ease;
`


class Bar extends Component {
  static propTypes = {
    progressPercentage: PropTypes.number
  };
  static defaultProps = {
    progressPercentage: 0
  };


  constructor(props) {
    super(props)
    this.state = {}
  }


  render() {
    const idNamespace = id("Bar", this.props)

    return (
      <Wrapper id={idNamespace}>
        <Seek id={id("seek", idNamespace)} style={{width: `${this.props.progressPercentage}%`}} />
      </Wrapper>
    )
  }
}

export default Bar
